import { createClient } from '@supabase/supabase-js';

// ══════════════════════════════════════════════════════════
//  REPLACE THESE WITH YOUR SUPABASE PROJECT VALUES
//  (Settings → API in your Supabase dashboard)
// ══════════════════════════════════════════════════════════
const SUPABASE_URL = 'https://nuixrqyzzwkpdwzzkjsg.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im51aXhycXl6endrcGR3enpranNnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM5NzUzODUsImV4cCI6MjA4OTU1MTM4NX0.41hCtjD8ZgMbYYg2pSWDcVxUXwO3xB4zBKY7KiLPW84';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
